import { Component, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { BoothService } from '../booth.service';
import { Zone, BoothType, Constituency, Ward, LocationCategory } from './../booth-interface.service';
import { GlobalValidationService } from 'src/app/global-validation.service';


@Component({
  selector: 'app-booth-register',
  templateUrl: './booth-register.component.html',
  styleUrls: ['./booth-register.component.scss']
})


export class BoothRegisterComponent {

  booth_register_form: FormGroup;
  action: 'register' | 'update' = null;
  zones: Zone[] = [];
  booth_types: BoothType[] = [];
  constituencies: Constituency[] = [];
  wards: Ward[] = [];
  isLinear = false;
  booth_name: any;
  product_price: any = null;
  location_categories: LocationCategory[] = [];
  products: any;
  display_product_prices: boolean = false;
  name_available = false;
  name_available_already = false;
  update_option = false;
  code_generated = false;
  disable_business_type_selection = false
  register_on_process = false;
  entered_code: any;
  showError: boolean;
  constructor(private http: HttpService, private global: GlobalService, private formBuilder: FormBuilder, public boothService: BoothService, private ref: ChangeDetectorRef) {
    console.log('booth register constructor run');
    this.booth_register_form = this.formBuilder.group({
      id: [null],
      name: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      zone_id: [null, Validators.compose([Validators.required])],
      business_type_id: [null, Validators.compose([Validators.required])],
      constituency_id: [null, Validators.compose([Validators.required])],
      ward_id: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      is_rural: [false],
      location_category_id: [null, Validators.compose([Validators.required])],
      pincode: [null, Validators.compose([GlobalValidationService.checkPincode])],
      location_category_value: [null, Validators.compose([Validators.required])],
      landmark: [null],
      working_hours_from: ['09:00'],
      working_hours_to: ['06:00'],
    });

    if (this.boothService.get_booth_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.disable_business_type_selection = true
      this.code_generated = true;
      this.update_option = true;
      this.booth_register_form.reset();
      this.setupUpdateForm(this.boothService.get_booth_data);
      if (this.boothService.get_booth_data['business_type_id'] == 4 || this.boothService.get_booth_data['business_type_id'] == 5 || this.boothService.get_booth_data['business_type_id'] == 6) {
        const data_dict = {
          'booth_id': this.boothService.get_booth_data['id']
        }
        this.display_product_prices = true;
        this.http.getProductDiscountPriceForUpdate(data_dict).subscribe((prices) => {
          console.log(prices);
          this.product_price = prices;
          console.log(this.product_price);
          this.ref.detectChanges;
        });
      }
    }
    console.log(this.action);

    console.log('zone register constructor');
    this.boothService.boothUpdate.subscribe((zone) => {
      console.log(zone);
      console.log(zone);
      if (zone === null) {
        this.action = 'register';
        this.booth_register_form.reset();
      } else {
        if (zone['business_type_id'] == 4 || zone['business_type_id'] == 5 || zone['business_type_id'] == 6) {
          const data_dict = {
            'booth_id': zone['id']
          };
          this.display_product_prices = true;
          this.http.getProductDiscountPriceForUpdate(data_dict).subscribe((prices) => {
            console.log(prices);
            this.product_price = prices;
            console.log(this.product_price);
            this.ref.detectChanges;
          });
        }
        this.action = 'update';
        this.disable_business_type_selection = true;
        this.code_generated = true;
        this.update_option = true;
        this.booth_register_form.reset();
        this.setupUpdateForm(zone);
      }
    });
    this.getFormCvs();
  }

  getFormCvs() {
    this.getZones();
    this.getBusinessTypes();
    this.getConstituencies();
    this.getWards();
    this.getLocationCategories();
    this.getProducts();

  }

  getProducts() {
    this.http.getProductwithMrp().subscribe((data) => {
      console.log(data);
      this.products = data;
      this.generateProductPriceDict();
    })
  }

  generateProductPriceDict() {
    this.product_price = {}
    // this.products.forEach(element => {
    //   this.product_price[element.name] = element.mrp
    // });
  }

  activateBoothDetail() {
    if (this.booth_register_form.controls.zone_id.valid && this.booth_register_form.controls.constituency_id.valid && this.booth_register_form.controls.ward_id.valid &&
      this.booth_register_form.controls.address.valid && this.booth_register_form.controls.location_category_id.valid && this.booth_register_form.controls.location_category_value.valid
      && this.booth_register_form.controls.pincode.valid && this.booth_register_form.controls.is_rural.valid) {
      return false;
    }
    else {
      return true;
    }
  }

  checkCode() {
    const data_dict = {
      'business_code': this.booth_register_form.value.code
    }
    console.log(data_dict);
    this.http.generateBoothCode(data_dict).subscribe((data) => {
      console.log(data);
      if (!data) {
        this.code_generated = true;
        this.showError = false;
      }
      else {
        this.showError = true;
        this.code_generated = false;
        this.booth_register_form.controls['code'].setValue(null);
      }
    })
  }

  getZones() {
    this.http.getZones().subscribe((data: Zone[]) => {
      console.log(data);
      this.zones = data;
    }, (error) => {
      console.log(error);
    });
  }

  onChange(event) {
    console.log(event)
    this.product_price = {}
    this.generateProductPriceDict();
    if (event == 4 || event == 5 || event == 6) {
      this.display_product_prices = true;
      if (event == 4) {
        this.products.forEach((data) => {
          if (data.private_institute_price != null) {
            this.product_price[data.id] = data.private_institute_price
          }
        })
      }
      if (event == 5) {
        this.products.forEach((data) => {
          if (data.govt_institute_price != null) {
            this.product_price[data.id] = data.govt_institute_price
          }
        })
      }
      console.log(this.product_price);
    }
    else {
      this.display_product_prices = false;
      this.product_price = {}
    }
    this.code_generated = false;
    this.booth_register_form.controls['code'].setValue(null);
  }

  displayProducts() {
    console.log(this.product_price)
  }

  getBusinessTypes() {
    this.http.getBoothTypes().subscribe((data: BoothType[]) => {
      console.log(data);
      this.booth_types = data;
    }, (error) => {
      console.log(error);
    });
  }

  getConstituencies() {
    this.http.getConstituency().subscribe((data: Constituency[]) => {
      console.log(data);
      this.constituencies = data;
    }, (error) => {
      console.log(error);
    });
  }

  getWards() {
    this.http.getWardsBasedOnConstituency().subscribe((data: any) => {
      this.wards = data;
      console.log(data);
    })
    // this.http.getWards().subscribe((data: Ward[]) => {
    //   console.log(data);
    // }, (error) => {
    //   console.log(error);
    // });
  }

  getLocationCategories() {
    this.http.getLocationCategories().subscribe((data: LocationCategory[]) => {
      console.log(data);
      this.location_categories = data;
    }, (error) => {
      console.log(error);
    });
  }

  registerBooth() {
    this.register_on_process = true;
    console.log(this.booth_register_form.value)
    this.booth_register_form.value['product_price'] = this.product_price
    this.http.registerBooth(this.booth_register_form.value).subscribe((data) => {
      console.log(data);
      this.booth_register_form.reset();
      this.global.showSnakeBar(data['message']);
      this.boothService.downloadBooth.emit(true);
      this.boothService.is_display_booth_register_component = false
      this.register_on_process = false;
    }, (error) => {
      console.log(error);
      alert('Error on register');
      this.register_on_process = false;
    });
  }

  setupUpdateForm(booth) {
    console.log(booth);

    this.booth_name = booth['name']
    this.booth_register_form.controls['id'].setValue(booth['id']);
    this.booth_register_form.controls['name'].setValue(booth['name']);
    this.booth_register_form.controls['code'].setValue(booth['code']);
    this.booth_register_form.controls['zone_id'].setValue(booth['zone_id']);
    this.booth_register_form.controls['business_type_id'].setValue(booth['business_type_id']);
    this.booth_register_form.controls['constituency_id'].setValue(booth['constituency_id']);
    this.booth_register_form.controls['ward_id'].setValue(booth['ward_id']);
    this.booth_register_form.controls['address'].setValue(booth['address']);
    this.booth_register_form.controls['pincode'].setValue(booth['pincode']);
    this.booth_register_form.controls['location_category_id'].setValue(booth['location_category_id']);
    this.booth_register_form.controls['location_category_value'].setValue(booth['location_category_value']);
    this.booth_register_form.controls['landmark'].setValue(booth['landmark']);
    this.booth_register_form.controls['is_rural'].setValue(booth['is_rural']);
    this.booth_register_form.controls['working_hours_from'].setValue(booth['working_hours_from']);
    this.booth_register_form.controls['working_hours_to'].setValue(booth['working_hours_to']);
  }

  // checkNameAvailbility() {
  //   const data_dict = {
  //     'booth_name': this.booth_name
  //   }
  //   this.http.checkForBoothNameAvailbility(data_dict).subscribe((data: boolean)=> {
  //     console.log(data);
  //     this.name_available = data;
  //     if (this.name_available) {
  //       this.booth_register_form.controls['name'].setValue(this.booth_name);
  //     }
  //     else {
  //       this.name_available_already = true;
  //     }
  //   })
  // }
}
